import { RootState } from '@/context/store';

import { EDisplays, EJourneys, EModals } from '../types';

export const selectDisplay = (state: RootState): EDisplays =>
    state.displayReducer.display;
export const selectPreviousDisplay = (
    state: RootState
): EDisplays | undefined => state.displayReducer.previousDisplay;
export const selectModal = (state: RootState): EModals | null =>
    state.displayReducer.modal;
export const selectIsLoaded = (state: RootState): boolean =>
    state.displayReducer.isLoaded;
export const selectIllionCodes = (
    state: RootState
): {
    threeMonths: string;
    sixMonths: string;
    twelveMonths: string;
} => state.displayReducer.illionCodes;
export const selectNovatedCost = (
    state: RootState
):
    | {
          medicare: number;
          taxPayable: number;
          monthlySaving: number;
          annualSaving: number;
          termSaving: number;
          novated: {
              financeOnly: number;
              fullyMaintained: number;
              annualSaving: number;
              fuel: number;
              registration: number;
              maintenanceRepairs: number;
              tyres: number;
              insurance: number;
              adminFee: number;
              totalLeaseRentalExGST: number;
              preTaxDeduction: number;
              postTaxDeduction: number;
          };
          consumer: {
              financeOnly: number;
              fullyMaintained: number;
              annualSaving: number;
              fuel: number;
              registration: number;
              maintenanceRepairs: number;
              tyres: number;
              insurance: number;
              adminFee: number;
              totalLeaseRentalExGST: number;
              preTaxDeduction: number;
              postTaxDeduction: number;
          };
      }
    | undefined => state.displayReducer.novatedCost;
export const selectIsAssetAndLiabilitiesSubmitSkipped = (
    state: RootState
): boolean => state.displayReducer.isAssetAndLiabilitiesSubmitSkipped;

export const selectShowScanwarePopup = (state: RootState): boolean =>
    state.displayReducer.showScanwarePopup;
export const selectScanwareQrId = (state: RootState): string | undefined =>
    state.displayReducer.scanwareQrId;
export const selectInitialJourney = (state: RootState): EJourneys =>
    state.displayReducer.initialJourney;
export const selectVehicleManualEntry = (state: RootState): boolean =>
    state.displayReducer.vehicleManualEntry;

export const selectIsPriceKnownViaExternal = (state: RootState): boolean =>
    state.displayReducer.isPriceKnownViaExternal;
export const selectSmsRequestAttempts = (state: RootState): number =>
    state.displayReducer.smsRequestAttempts;
export const selectSmsLastRequestTimestamp = (state: RootState): Date | null =>
    state.displayReducer.smsLastRequestTimestamp;
